import { CTAColorVariant } from '~/components/shared/CTAButton';

export interface SimplifiedSolidHeroProps {
  variant: 'blue' | 'spark-yellow' | 'sunrise-yellow';
  headline: string;
  subheadline: string;
  disclaimer: string;
  disclaimerLink: string;
  CTAButtonText: string;
  CTAButtonVariant: CTAColorVariant;
  CTAButtonLink: string;
  hasSecondaryCTAButton: boolean;
  secondaryCTAButtonText: string;
  secondaryCTAButtonVariant: CTAColorVariant;
  secondaryCTAButtonLink: string;
  [key: string]:
    | string
    | boolean
    | CTAColorVariant
    | ('blue' | 'spark-yellow' | 'sunrise-yellow');
}

export const DEFAULT_PROPS: SimplifiedSolidHeroProps = {
  variant: 'blue',
  headline: 'Try Walmart+ free for 30 days',
  subheadline:
    'Save more with free delivery, free returns from home, gas savings & more.',
  disclaimer:
    '_1_Compared against 2 deliveries/wk at non-member $7.95 fee + 2 Walmart.com orders under $35/wk at non-member $6.99 shipping fee. Restrictions apply.',
  disclaimerLink: '_EMPTY_',
  CTAButtonText: 'Claim your free trial',
  CTAButtonVariant: 'primary-yellow' as CTAColorVariant,
  CTAButtonLink: 'https://www.walmart.com/plus/plans',
  hasSecondaryCTAButton: false,
  secondaryCTAButtonText: 'Or try free for 30 days',
  secondaryCTAButtonVariant: 'text-link' as CTAColorVariant,
  secondaryCTAButtonLink: 'https://www.walmart.com/plus/plans',
};
